module.exports = __webpack_public_path__ + "img/9788992820158.079c1cd1.jpg";